import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface ShowcaseItem {
  id: number | string;
  title: string | null;
  topic: string | null;
  platform: string | null;
  prompt: string | null;
  model: string | null;
  video_url: string | null;
  thumbnail_url: string | null;
}

interface ShowcaseResponse {
  items: ShowcaseItem[];
}

export function useShowcase() {
  return useQuery<ShowcaseResponse>({
    queryKey: ['showcase'],
    queryFn: async () => {
      const response = await api.get('/showcase');
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
    retry: 2,
  });
}
